export const AUTH0_CLIENT_ID = 'jQgE6murTkAELSikwbpNQzjSSg_3g1zi';
export const AUTH0_DOMAIN = 'eviviz.auth0.com';
// tslint:disable-next-line: max-line-length
export const AUTH_ENDPOINT = 'https://sarepta-portfolio.api.eviviz.com/auth';
export const AUTH_APP_NAME = `dmd-utilities`;
